import styled from 'styled-components';

export const EachCartItemContainer = styled.article`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: flex-start;
  gap: var(--space-m);

  width: 100%;
  padding: var(--space-l);
  background: linear-gradient(
    135deg,
    var(--white) 0%,
    rgba(255, 240, 194, 0.13) 100%
  );

  border: 1px solid var(--grey1);
  /* border-left: 3px solid transparent; */
  border-radius: var(--borderRadius);

  box-shadow: var(--shadow-xs);

  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;

  &:hover {
    border-left-color: var(--yellow4);

    box-shadow: var(--shadow-sm);

    transform: translateY(-1px);
  }

  @media screen and (max-width: 600px) {
    gap: var(--space-s);

    padding: var(--space-m);

    border-radius: var(--borderRadiusSmall);
  }
`;

export const CartItemContent = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--space-xs);

  min-width: 0;

  a {
    width: fit-content;

    text-decoration: none;

    &:hover h5 {
      color: var(--orange5);
    }
  }
`;

export const CartItemTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: var(--space-l);

  padding-right: var(--space-xs);

  @media screen and (max-width: 600px) {
    gap: var(--space-s);
    padding-right: 0;
  }
`;

export const CourseName = styled.h5`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1rem, 2vw, 1.12rem);
  font-weight: 750;
  line-height: 1.3;
  letter-spacing: -0.015em;

  transition: color 0.2s ease;
`;

export const PriceValue = styled.p`
  margin: 0;

  color: var(--grey7);

  font-size: 1rem;
  font-weight: 800;
  line-height: 1.35;

  white-space: nowrap;

  @media screen and (max-width: 600px) {
    font-size: 0.92rem;
  }
`;

export const CartItemDetails = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  gap: 0.4rem;

  color: var(--grey4);

  font-size: 0.84rem;
  font-weight: 500;
  line-height: 1.5;

  span + span {
    position: relative;

    padding-left: 1rem;

    &::before {
      content: '•';

      position: absolute;
      left: 0.2rem;
      top: 50%;

      transform: translateY(-50%);

      color: var(--orange4);

      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;

    gap: 0.15rem;

    span + span {
      padding-left: 0;

      &::before {
        display: none;
      }
    }
  }
`;

export const Part2Inline = styled.p`
  width: fit-content;
  max-width: 620px;

  margin: var(--space-xs) 0 0;
  padding: 0.45rem 0.7rem;

  color: var(--grey5);

  background: var(--yellow1);

  border: 1px solid var(--yellow3);
  border-radius: var(--borderRadiusButton);

  font-size: 0.76rem;
  font-weight: 550;
  line-height: 1.45;

  strong {
    color: var(--grey7);

    font-weight: 800;
  }

  @media screen and (max-width: 500px) {
    width: 100%;

    border-radius: var(--borderRadiusSmall);
  }
`;

export const DeleteCartButtonStyled = styled.div`
  flex-shrink: 0;

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 34px;
    height: 34px;

    padding: 0;

    color: var(--grey4);

    background: var(--white);

    border: 1px solid var(--grey1);
    border-radius: 50%;

    box-shadow: var(--shadow-xs);

    cursor: pointer;

    transition:
      color 0.2s ease,
      background 0.2s ease,
      border-color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      color: var(--errorRed);

      background: var(--lightRed);

      border-color: rgba(208, 17, 36, 0.18);

      transform: scale(1.04);
    }

    &:focus-visible {
      outline: 2px solid var(--errorRed);
      outline-offset: 2px;
    }
  }

  @media screen and (max-width: 600px) {
    button {
      width: 32px;
      height: 32px;
    }
  }
`;
